import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from "@angular/router";
import { LeadSubmitService } from "./lead-submit.service";
import { ApiRoutes } from "../../../services/apiroutes";
import { AuthService } from 'src/app/services/auth.service';
import { ServiceMappingApiService } from 'src/app/services/domain_code/service-mapping-api.service';
import { DomainCode } from 'src/app/models/common/model';
import { BackendListModel } from 'src/app/models/common/list.model';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { ServiceMasterModel } from 'src/app/models/common/service-master.model';
import { LeadRequestModel } from './lead-request.model';
import { IRegisterModel, OtpModel, RegisterModel } from '../../authentication/register/register.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RegisterApiService } from '../../authentication/register/register-api.service';
import { RequirementError, RequirementsModel } from '../../one-way-data/request/requirements-model';
import { SuccessBoxComponent } from 'src/app/components/dialog-box/success-box/success-box.component';
import { MatDialog } from '@angular/material/dialog';
import { FailureBoxComponent } from 'src/app/components/dialog-box/failure-box/failure-box.component';
import { WarningBoxComponent } from 'src/app/components/dialog-box/warning-box/warning-box.component';

@Component({
    selector: 'logzy-lead-submit',
    templateUrl: './lead-submit.component.html',
    styleUrls: ['../request-details.scss', './lead-submit.component.scss']
})
export class LeadSubmitComponent implements OnInit {

    isRequestEditable: boolean = true;
    isEmailEditable: boolean = false;
    disableFields: boolean = false;
    emailUpdate: boolean = false;
    display: any;
    resendOtp: boolean = false;
    displayTimer: boolean = false;
    requestObj: LeadRequestModel;
    otpTimer = null;

    registerObj: RegisterModel;
    otp_obj: OtpModel;
    numberOfYears = [0, 1, 2, 3, 4, 5, 6];
    numberOfMonths = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

    //set step true to be on step, keep only one step true for now
    step1: boolean = true;
    step2: boolean = false;
    step3: boolean = false;
    isEmailVerified: boolean = false;
    isOtpVerified: boolean = false;
    verifyAnimate: boolean = false;
    disableRequestProceedButton: boolean = false;
    disableBasicDetailsProceedButton: boolean = false;
    disableVerifyButton: boolean = false;
    disableSetPasswordProceedButton: boolean = false;
    verificationResponse;
    leadResponse;
    showError: boolean = false;
    // activeStep: string = 'step1';
    // backToStep: string;
    emailToolTip: string = 'Edit email id';
    transactionTypeBtns: DomainCode[] = [];
    requestTypeList: BackendListModel<ServiceMasterModel>;
    containerConditionList: BackendListModel<DomainCode>;
    superLocationSourceLabel: string = 'Pick-up Location';
    superLocationDestinationLabel: string = 'Drop-off Location';

    containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
    companySearchUrl = `${ApiRoutes.Company}register/?search=::search::`;
    country_url: string = `${ApiRoutes.Geo}country/?name=::search::`;
    state_url: string = `${ApiRoutes.Geo}state/?name=::search::`;


    rain = {
        fullScreen: {
            zIndex: 1
        },
        particles: {
            color: {
                value: [
                    "#F05F25",
                    "#414042",
                    "#9E9E9E",
                    "#FF9064"
                ]
            },
            move: {
                // direction: MoveDirection.bottom,
                // enable: true,
                // outModes: {
                //     default: OutMode.out,
                // },
                // size: true,
                // speed: {
                //     min: 1,
                //     max: 3
                // }
            },
            number: {
                value: 500,
                density: {
                    enable: true,
                    area: 800
                }
            },
            opacity: {
                value: 1,
                animation: {
                    enable: false,
                    // startValue: StartValueType.max,
                    // destroy: DestroyType.min,
                    speed: 0.3,
                    sync: true
                }
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360
                },
                direction: "random",
                move: true,
                animation: {
                    enable: true,
                    speed: 60
                }
            },
            tilt: {
                direction: "random",
                enable: true,
                move: true,
                value: {
                    min: 0,
                    max: 360
                },
                animation: {
                    enable: true,
                    speed: 60
                }
            },
            shape: {
                type: [
                    "circle",
                    "square"
                ],
                options: {}
            },
            size: {
                value: {
                    min: 2,
                    max: 4
                }
            },
            roll: {
                darken: {
                    enable: true,
                    value: 30
                },
                enlighten: {
                    enable: true,
                    value: 30
                },
                enable: true,
                speed: {
                    min: 15,
                    max: 25
                }
            },
            wobble: {
                distance: 30,
                enable: true,
                move: true,
                speed: {
                    min: -15,
                    max: 15
                }
            }
        },
        duration: 6,
        style: {
            transition: 'opacity 2s ease-out 2s',
            opacity: '0'
        }
    }
    showVideo: boolean = false;

    // async particlesInit(engine: Engine): Promise<void> {
    //     // console.log(engine);

    //     // Starting from 1.19.0 you can add custom presets or shape here, using the current tsParticles instance (main)
    //     // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    //     // starting from v2 you can add only the features you need reducing the bundle size
    //     await loadFull(engine);
    // }

    constructor(
        private domainService: DomainCodeApiService,
        private route: ActivatedRoute,
        private router: Router,
        private mappingService: ServiceMappingApiService,
        private leadSubmitService: LeadSubmitService,
        private authService: AuthService,
        private dialog: MatDialog,
        private registerService: RegisterApiService,
    ) {
    }

    ngOnInit(): void {
        this.resetComponent();
    }

    ngOnDestroy() {
        if (this.otpTimer) {
            clearInterval(this.otpTimer);
        }
    }

    resetComponent() {
        this.requestObj = new LeadRequestModel();
        this.registerObj = new RegisterModel();
        this.otp_obj = new OtpModel();
        this.getRequestTypeList();
        this.getContainerCondition();
        this.getTransactionTypes();
    }

    setStep(active) {
        localStorage.setItem('step', active)
        if (this.isOtpVerified) {
            return
        }
        switch (active) {
            case 'step1':
                this.step1 = true;
                this.step2 = false;
                this.step3 = false;
                this.isRequestEditable = true;
                this.disableRequestProceedButton = false;
                break;
            case 'step2':
                this.step1 = false;
                this.step2 = true;
                this.step3 = false;
                this.disableBasicDetailsProceedButton = false
                break;
            case 'step3':
                this.step1 = false;
                this.step2 = false;
                this.step3 = true;
                this.disableVerifyButton = false;
                break;
        }
    }

    backFromOtpDetails() {
        this.disableBasicDetailsProceedButton = false;
        this.setStep('step2')
    }

    // getLeadById(id) {
    //     this.leadSubmitService.getLeadById(id).subscribe({
    //         next: res => {
    //             this.requestObj.saveLeadPayloadToModel(res);
    //             if (localStorage.getItem('step')) {
    //                 this.setStep(localStorage.getItem('step'));
    //                 if (localStorage.getItem('step') == 'step3') {
    //                     this.startResendOtpTimer(0.25);
    //                 }
    //             }
    //         },
    //         error: err => {
    //             console.log(err);
    //         }
    //     })
    // }

    getRequestTypeList() {
        this.mappingService.getUserServiceList().subscribe({
            next: response => {
                this.requestTypeList = response;
                this.route.queryParams.subscribe(params => {
                    if (params['request_type']) {
                        for (let i = 0; i < this.requestTypeList.results.length; i++) {
                            if (this.requestTypeList.results[i].dev_name == params['request_type']) {
                                this.requestObj.request_type = this.requestTypeList.results[i];
                            }
                        }
                    }
                });
            },
            error: error => {
                console.log(error)
                return error;
            }
        });
    }

    getTransactionTypes() {
        this.domainService.getByGroup(null, 'LeadRequestTransactionTypes').subscribe({
            next: response => {
                this.transactionTypeBtns = response.results;
                this.route.queryParams.subscribe(params => {
                    if (params['transaction_type'] && params['request_type']) {
                        for (let i = 0; i < this.transactionTypeBtns.length; i++) {
                            if (this.transactionTypeBtns[i].group == `LeadRequestTransactionTypes_${params['request_type']}`) {
                                if (this.transactionTypeBtns[i].dev_value == params['transaction_type'] && this.requestObj.request_type.dev_name != 'lease') {
                                    this.requestObj.transaction_type = this.transactionTypeBtns[i].dev_value;
                                }
                            }
                        }
                    }
                });
            }, error: error => {
                return error;
            }
        });
    }

    getContainerCondition(grp = 'ContainerCondition') {
        this.domainService.getByGroup(grp).subscribe({
            next: response => {
                this.containerConditionList = response;
            },
            error: error => {
                return error;
            }
        });
    }

    addRequirements() {
        this.requestObj.requirements.push(new RequirementsModel());
        this.requestObj.error.requirements.push(new RequirementError());
    }

    removeRequirements(idx) {
        this.requestObj.requirements.splice(idx, 1);
        this.requestObj.error.requirements.splice(idx, 1);
    }

    selectTransactionType(transactionType: string) {
        this.requestObj.transaction_type = transactionType;
    }

    getLocationLabelsByRequestType(event) {
        if (event != null && !this.requestObj.id) {
            this.requestObj.resetErrors();
            this.requestObj.request_type = event;
            this.requestObj.requirements = [new RequirementsModel()];
            this.requestObj.error.requirements = [new RequirementError()];
            switch (event.dev_name) {
                case 'one_way':
                    this.requestObj.transaction_type = 'use';
                    this.superLocationSourceLabel = 'Pick-up Location';
                    this.superLocationDestinationLabel = 'Drop-off Location';
                    this.requestObj.error.request_type = [];
                    break;
                case 'buy_sell':
                    this.requestObj.transaction_type = 'use';
                    this.superLocationSourceLabel = 'Buy Location';
                    this.requestObj.pod_list = []
                    this.requestObj.error.request_type = [];
                    break;
                case 'lease':
                    this.requestObj.transaction_type = 'use';
                    this.superLocationSourceLabel = 'On-hire Location';
                    this.superLocationDestinationLabel = 'Off-hire Location';
                    this.requestObj.error.request_type = [];
                    break;
            }
            this.setRequestTypeParam(event.dev_name);
        }
    }

    setRequestTypeParam(requestType: string) {
        if (!this.requestObj.id) {
            this.router.navigate([], {
                queryParams: {
                    'request_type': requestType,
                },
                queryParamsHandling: 'merge'
            });
        }
    }

    getLocationLabelByTransactionType(event) {
        if (event != null) {
            if (this.requestObj.request_type.dev_name == 'buy_sell' && event == 'use') {
                this.superLocationSourceLabel = 'Buy Location'
            }
            if (this.requestObj.request_type.dev_name == 'buy_sell' && event == 'supply') {
                this.superLocationSourceLabel = 'Sell Location'
            }
        }
    }

    resetPolsError(event) {
        if (this.requestObj.pol_list.length) {
            this.requestObj.error.pol_list = [];
            return;
        }
    }

    resetPodsError(event) {
        if (this.requestObj.pod_list.length) {
            this.requestObj.error.pod_list = [];
            return;
        }
    }

    setCountryByMobileNumber(event) {
        if (event != null) {
            this.requestObj.mobile = event;
            this.registerObj.phone = event
            this.registerObj.country = event.country;
            this.registerObj.state = null;
            this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${event.country.id}`;
        }
    }

    saveRequest() {
        this.disableRequestProceedButton = true;
        if (this.requestObj.is_valid()) {
            this.setNameFromEmail(this.requestObj.email);
            this.saveLead();
        } else {
            this.disableRequestProceedButton = false;
        }
    }

    saveLead() {
        this.leadSubmitService.postLead(this.requestObj.getLeadRequestData()).subscribe({
            next: res => {
                if (res.status == 207) {
                    this.openSuccessDialog('verifyOtp', `The lead has been successfully generated.`, `Kindly wait for Admin's approval.`, `OK`);
                } else {
                    this.registerObj.lead_request = [res.body.id];
                    this.requestObj.saveLeadPayloadToModel(res.body);
                    if (this.authService.getAuthStatus()) {
                        this.router.navigate([this.requestObj.getDetailUrl(this.requestObj.request_type.dev_name)], { queryParams: { lead_id: res.body.id } });
                        // this.router.navigateByUrl(`/web-request/lead-request-create?lead_id=${res.id}`);
                        localStorage.removeItem('step');
                    } else {
                        if (res.body.token != null) {
                            localStorage.setItem('lead_request', JSON.stringify(res.body));
                            this.authService.redirectToUrl = this.router.url.split('?')[0];
                            this.navigateToLogin();
                        } else {
                            this.isRequestEditable = false;
                            // this.router.navigate([], {
                            //     queryParams: {
                            //         'request_type': null,
                            //     },
                            //     queryParamsHandling: 'merge'
                            // });
                            this.setStep("step2");
                        }
                        this.disableBasicDetailsProceedButton = false;
                        this.isEmailEditable = false;
                        this.emailToolTip = 'Edit email id';
                    }
                }
            },
            error: err => {
                if (err.status == 400) {
                    if (err.error?.internal_warning_email?.length) {
                        this.openFailureDialog('internal_warning', err.error?.internal_warning_email[0], 'Go to Login')
                    }
                    if (err.error?.external_warning_email?.length) {
                        let dialogError = err.error?.external_warning_email[0].split('.')
                        this.openFailureDialog('external_warning', dialogError[0] + '.', dialogError[1] + '.', 'OK')
                    }
                    this.requestObj.patchErrors(err.error);
                }
                if (err.status == 405) {
                    alert(`Something went wrong (${err.statusText})`);
                }
                this.disableRequestProceedButton = false;
                console.log(err)
            }
        })
    }

    setEmail(email) {
        if (email != null) {
            this.requestObj.email = email;
            this.registerObj.email = email;
        }
    }

    setNameFromEmail(email) {
        let breakpoint = /\_|\.|\@/
        if (email != null) {
            const splittedString = email.split(breakpoint);
            if (splittedString.length) {
                if (this.registerObj.first_name == null || this.registerObj.first_name == '') {
                    this.registerObj.first_name = splittedString[0];
                }
                if (this.registerObj.last_name == null || this.registerObj.last_name == '') {
                    this.registerObj.last_name = splittedString[1];
                }
            }
        }
    }

    toggleEmailEditing(event) {
        if (!this.isEmailEditable) {
            this.isEmailEditable = true;
            this.disableBasicDetailsProceedButton = true;
            this.emailToolTip = 'Update email id';
        } else {
            if (event != null) {
                this.requestObj.email = event;
                this.registerObj.email = event;
            }
            this.saveLead();
        }
    }
    //use this to enable the shimmer for 9 secs on email update
    emailUpdated() {
        setTimeout(() => {
            this.emailUpdate = true;
        }, 100);
        setTimeout(() => {
            this.emailUpdate = false;
        }, 9000);
    }

    filterStates(country) {
        if (country != null) {
            if (country.id != this.registerObj.country?.id) {
                this.registerObj.country = country;
                this.registerObj.state = null
                this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${country.id}`;
                this.registerObj.address = `${this.registerObj.state != null ? this.registerObj.state.name + ', ' : ''}${this.registerObj.country != null ? this.registerObj.country.name : ''}`
            }
        } else {
            this.registerObj.country = null;
        }
    }

    onStateChange(state) {
        if (state != null) {
            this.registerObj.state = state;
            this.registerObj.address = `${this.registerObj.state != null ? this.registerObj.state.name + ', ' : ''}${this.registerObj.country != null ? this.registerObj.country.name : ''}`
        }
    }

    sendOtp() {
        this.disableBasicDetailsProceedButton = true;
        if (this.registerObj.validate()) {
            this.registerService.registerUser(this.registerObj.getRegisterPayload()).subscribe({
                next: (data: IRegisterModel) => {
                    this.otp_obj.token = data.token;
                    this.startResendOtpTimer(data.throttle_period / 60);
                    this.isRequestEditable = false;
                    this.setStep('step3');
                },
                error: (error: any) => {
                    if (error.status == 400) {
                        this.registerObj.errors = { ...error.error };
                        if (this.registerObj.errors.redirect_to_login?.length > 0) {
                            this.openWarningDialog('Your email is already registered with the system.', 'You can directly Login.', 'Back', 'Login Now')
                        }
                    }
                    this.disableBasicDetailsProceedButton = false;
                }
            });
        } else {
            this.disableBasicDetailsProceedButton = false;
        }
    }

    startResendOtpTimer(minute) {
        clearInterval(this.otpTimer);
        this.displayTimer = true;
        this.resendOtp = false;
        // let minute = 1;
        let seconds = minute * 60;
        let textSec: any = '0';
        let statSec = minute < 1 ? minute * 60 : 60;

        const prefix = minute < 10 ? '0' : '';

        this.otpTimer = setInterval(() => {
            seconds--;
            if (statSec != 0)
                statSec--;
            else
                statSec = 59;

            // if (statSec < 10) textSec = "0" + statSec;
            // textSec = statSec;

            if (statSec < 10) {
                textSec = '0' + statSec;
            } else {
                textSec = statSec;
            }

            this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

            if (seconds == 0) {
                clearInterval(this.otpTimer);
                this.resendOtp = true;
                this.displayTimer = false;
            }
        }, 1000);
    }

    verifyOtp() {
        this.disableVerifyButton = true;
        this.registerService.verifyEmailOTP(this.otp_obj.getOtpPayload()).subscribe({
            next: res => {
                localStorage.removeItem('step');
                this.openSuccessDialog('verifyOtp', `Thank you for your request.`, `Our team is on it. We would get back to you with the next steps`, `OK`);
            },
            error: err => {
                console.log("otp error", err)
                this.otp_obj.errors = { ...err.error };
                if (this.otp_obj.errors.otp.length) {
                    this.openFailureDialog('otpError', this.otp_obj.errors.otp[0], 'Please enter valid OTP')
                }
            }
        });
    }

    setPassword() {
        this.disableSetPasswordProceedButton = true;
        if (this.otp_obj.validatePassword()) {
            this.registerService.setPassword(this.otp_obj.getPasswordPayload()).subscribe({
                next: res => {
                    localStorage.removeItem('step');
                    localStorage.setItem('email', JSON.stringify(res));
                    this.verificationResponse = res;
                    if (this.verificationResponse?.approval_status == 'pending')
                        this.showError = true;
                    else
                        this.showError = false;
                    this.isEmailVerified = true;
                    setTimeout(() => {
                        this.verifyAnimate = true;
                    }, 300);
                    setTimeout(() => {
                        this.showVideo = true;
                    }, 2600);
                    // setTimeout(() => {
                    //     this.navigateToLogin();
                    // }, 5000);
                },
                error: err => {
                    console.log("otp error", err)
                    this.disableSetPasswordProceedButton = false;
                    this.otp_obj.errors = { ...err.error };
                }
            });
        } else {
            this.disableSetPasswordProceedButton = false;
        }
    }

    resendOtpOnEmail() {
        this.registerService.resendOTP({ token: this.otp_obj.token }).subscribe({
            next: res => {
                this.startResendOtpTimer(res.body.throttle_period / 60);
                this.openSuccessDialog('resend', `A secure 6-digit OTP has been sent on ${this.registerObj.email}.`, `Please check your inbox or SPAM folder and enter the OTP to complete the account creation.`, `Continue`);
            },
            error: err => {
                if (err.status == 429) {
                    let waitTime = Math.round(Number(err.error.wait) / 3600)
                    let label1 = `Please wait for ${waitTime} hour${waitTime > 1 ? 's' : ''} before trying again.`
                    let label2 = `It seems like you've tried multiple OTP resend attempts, you must have not recieved due to...<br><ol><li>You might have entered an invalid email address</li><li>Your orgnization's policies might have blocked the OTP mail</li><li>Check your SPAM folder</li></ol>`;

                    this.openFailureDialog('resendOtpError', label1, label2)
                    // alert(`${err.error.message} Wait for ${Math.round(Number(err.error.wait) / 3600)} hours before trying again.`);
                }
                console.log(err)
            }
        });
    }

    navigateToLogin() {
        this.router.navigateByUrl('/authentication/login');
        localStorage.removeItem('step');
    }

    openSuccessDialog(type: string, label: string, description, btnLabel) {
        const dialogRef = this.dialog.open(SuccessBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: null, description: description, label1: btnLabel }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                switch (type) {
                    case 'resend':
                        this.isOtpVerified = false;
                        break;
                    case 'verifyOtp':
                        window.location.href = 'https://arconcontainer.com';
                        this.isOtpVerified = true;
                        break;
                }
            }
        })
    }

    openFailureDialog(type, label: string, description, action: string = null) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, parent: null, description: description, label1: action }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                switch (type) {
                    case 'otpError':
                        this.disableVerifyButton = false;
                        this.otp_obj.otp = null;
                        break;
                    case 'internal_warning':
                        this.navigateToLogin();
                        break;
                    case 'external_warning':
                        window.location.href = 'https://arconcontainer.com';
                        break;
                    case 'resendOtpError':
                        return;
                }
                return;
            }
        })
    }

    openWarningDialog(label: string, description, action1: string, action2: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: { subTitle: label, description: description, label1: action1, label2: action2 }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                this.navigateToLogin()
                return;
            } else {
                return;
            }
        });
    }

    // navigateToQuotation(requestData) {
    //     if (this.authService.isCustomer()) {
    //         this.router.navigateByUrl(`/client-dashboard/my-orders?id=${requestData.id}&add_expectation=${1}`);
    //     }
    //     if (!this.authService.isCustomer()) {
    //         this.router.navigateByUrl(`/requests/request-processing?id=${requestData.id}&first_quote=${1}`);
    //     }
    // }

}
